import type { Address, Client, CountryIso, Coupon, Discount, EmergencyContact, ExtraNationality, Occupation, PastVisit } from "~/types";
import phoneFactory from "./phone-factory";

export function emergencyContactFactory(baseCountry: CountryIso): EmergencyContact {
  return {
    name: '',
    phone: phoneFactory(baseCountry),
    address: addressFactory(baseCountry),
    relation: ''
  };
}

export function extraNationalityFactory(): ExtraNationality {
  return {
    status: 'none'
  };
}

export function clientFactory(baseCountry: CountryIso): Client {
  return {
    name: '',
    email: '',
    phone: phoneFactory(baseCountry),
    whatsappAlertsEnabled: false
  };
}

export function addressFactory(baseCountry: CountryIso): Address {
  return {
    country: baseCountry,
    city: '',
    line: ''
  };
}

export function occupationFactory(baseCountry: CountryIso): Occupation {
  return {
    education: 'highschool',
    status: 'employee',
    name: '',
    seniority: '2-5',
    phone: phoneFactory(baseCountry),
    address: addressFactory(baseCountry)
  };
}

export function discountFactory(): Discount {
  return {
    coupon: '',
    percent: 0
  };
}

export function pastVisitFactory(): PastVisit {
  return {
    visited: false,
    pastVisa: {
      number: '',
      dateOfIssue: ''
    }
  };
}

export function couponFactory(code: string): Coupon {
  return {
    code,
    discount: 5,
    activation_count: 0,
    order_count: 0
  };
}